import {
  ChoiceGroup,
  DatePicker,
  DefaultButton,
  IChoiceGroupOption,
  Icon,
  Label,
  Panel,
  PanelType,
  PrimaryButton,
  Stack,
} from "@fluentui/react";
import React, { useCallback, useEffect, useState } from "react";
import { PanelHeader } from "../../../../components/Panel/PanelHeader";
import { onFormatDate } from "../../../../utils/helpers/dateHelpers";
import { useComboEstados } from "../../../../hooks/combosHooks/useComboEstados";
import { useComboEquipoIperc } from "../../../../hooks/combosHooks/useComboEquipoIperc";
import { useComboActividadPorEquipo } from "../../../../hooks/combosHooks/useComboActividadPorEquipo";
import { ComboBoxIDS } from "../../../../components/generic/ComboBoxIDS";
import { IRequestAdminTableHistoricoIperc } from "../../../../Interfaces/IIpercBase";
import { useComboSupervisores } from "../../../../hooks/combosHooks/useComboSupervisores";
import { useComboGuardias } from "../../../../hooks/combosHooks/useComboGuardias";
import IPERCService from "../../../../services/IPERCService";
import { PanelFooter } from "../../../../components/Panel/PanelFooter";

interface IPanelAdminHistorialFilter {
  isOpen: boolean;
  onDismiss: () => void;
  onChangeComboBox: (e, o, string) => void;
  onChangeChoiceGroup: (e, o) => void;
  filter: IRequestAdminTableHistoricoIperc;
  limpiarFiltro: () => void;
  onSelectDate: (date, string) => void;
  fechasFilter: any;
  buscar: () => void;
}

export const PanelAdminHistorialFilter = (
  props: IPanelAdminHistorialFilter
) => {
  const [estados, setEstados] = useState<IChoiceGroupOption[]>([]);

  const {
    _onKeyUpSearchEquipoIperc,
    comboBoxRefEquipoIPERC,
    dataComboEquiposIperc,
    onClickComboBoxEquipoIPERC,
  } = useComboEquipoIperc();

  const { dataComboGuardia, comboBoxRefGuardias, onClickOpenGuardias } =
    useComboGuardias();
  const {
    SupervisoresCombo,
    _onkeyUpSearchSupervisores,
    comboBoxRefSupervisores,
    obtenerPuesto,
    onClickComboSupevisores,
  } = useComboSupervisores();

  const {
    dataComboActividad,
    onChangeEquipo,
    _onKeyUpSeaechComboActividad,
    comboBoxRefActividad,
    onClickComboBoxActividad,
  } = useComboActividadPorEquipo();

  const dataEstados = (search: string = "") => {
    IPERCService.comboEstados(search)
      .then((res) => {
        const data = res.data.data.map((x) => ({
          key: x.id,
          text: x.nombre,
        }));

        setEstados(data);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  useEffect(() => {
    dataEstados();
  }, []);

  const onRenderFooterPanel = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Buscar"
          texto2={"Limpiar"}
          onClick={props.buscar}
          disableButton={false}
          onDismiss={props.limpiarFiltro}
        />
      </>
    ),
    [props.onDismiss, props.limpiarFiltro]
  );

  const onRenderHeaderPanel = useCallback(
    () => (
      <PanelHeader
        textHeader="Filtro Avanzado Historial de IPERCs"
        subTextHeader={`Búsqueda Avanzada`}
      />
    ),
    []
  );

  return (
    <div>
      <Panel
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
        onRenderFooter={onRenderFooterPanel}
        onRenderHeader={onRenderHeaderPanel}
        isFooterAtBottom={true}
        isBlocking={false}
        closeButtonAriaLabel="Close"
        type={PanelType.medium}
        isLightDismiss
      >
        <br />
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <DatePicker
                label="Fecha de:"
                placeholder="dd/mm/yyyy"
                ariaLabel="Seleccione una fecha"
                value={props.fechasFilter?.filterFechaInicio}
                onSelectDate={(date?: any) => {
                  props.onSelectDate(date, "inicio");
                }}
                formatDate={onFormatDate}
                maxDate={new Date()}
                underlined
              />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <DatePicker
                label="a:"
                placeholder="dd/mm/yyyy"
                ariaLabel="Seleccione una fecha"
                value={props.fechasFilter?.filterFechaFin}
                onSelectDate={(date?: any) => {
                  props.onSelectDate(date, "fin");
                }}
                formatDate={onFormatDate}
                minDate={props.fechasFilter?.filterFechaInicio}
                maxDate={new Date()}
                underlined
              />
            </div>
          </div>
          <br />
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <Label id="labelElement">
                <Stack horizontal verticalAlign="center">
                  <span>Estados&nbsp;&nbsp;</span>
                  <Icon iconName="Filter" />
                </Stack>
              </Label>
              <ChoiceGroup
                options={estados}
                selectedKey={props.filter?.estadoId}
                onChange={(e, o) => props.onChangeChoiceGroup(e, o)}
                ariaLabelledBy="labelElement"
              />
            </div>
          </div>
          <br />
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <ComboBoxIDS
                title="Supervisor:"
                componentRef={comboBoxRefSupervisores}
                selectedKey={props.filter?.supervisorId}
                KeyUp={_onkeyUpSearchSupervisores}
                onChange={(e, o) => {
                  props.onChangeComboBox(e, o, "supervisor");
                }}
                onClick={onClickComboSupevisores}
                options={SupervisoresCombo}
                onRenderOption={(option) => (
                  <>
                    {option && (
                      <div>
                        <span>{option?.text}</span>
                        <br />
                        <span
                          style={{
                            paddingBottom: "0.9px",
                            color: "#777",
                            fontSize: "0.7rem",
                          }}
                        >
                          {obtenerPuesto(option?.key)}
                        </span>
                      </div>
                    )}
                  </>
                )}
              />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <ComboBoxIDS
                title="Guardia:"
                componentRef={comboBoxRefGuardias}
                selectedKey={props.filter?.guardia}
                onChange={(e, o) => {
                  props.onChangeComboBox(e, o, "guardia");
                }}
                onClick={onClickOpenGuardias}
                options={dataComboGuardia}
              />
            </div>
          </div>
          <br />
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <ComboBoxIDS
                title="Equipo:"
                componentRef={comboBoxRefEquipoIPERC}
                selectedKey={props.filter?.equipoId}
                onChange={(e, o) => {
                  props.onChangeComboBox(e, o, "equipo");
                  onChangeEquipo(e, o);
                }}
                KeyUp={_onKeyUpSearchEquipoIperc}
                onClick={onClickComboBoxEquipoIPERC}
                options={dataComboEquiposIperc}
              />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
              <ComboBoxIDS
                title="Actividad:"
                componentRef={comboBoxRefActividad}
                KeyUp={_onKeyUpSeaechComboActividad}
                selectedKey={props.filter?.actividadId}
                onChange={(e, o) => {
                  props.onChangeComboBox(e, o, "actividad");
                }}
                onClick={onClickComboBoxActividad}
                options={dataComboActividad}
              />
            </div>
          </div>
        </div>
      </Panel>
    </div>
  );
};
